export const PATHWAY_PROFILE_ERROR = 'PATHWAY_PROFILE_ERROR';
export const PATHWAY_PROFILE_LOADING = 'PATHWAY_PROFILE_LOADING';
export const PATHWAY_PROFILE_SUCCESS = 'PATHWAY_PROFILE_SUCCESS';